<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div class="d-flex align-center">
        <v-icon color="indigo darken-1" class="mr-3" size="28">mdi-cog</v-icon>
        <h3 class="mb-0">NFT for Redemption</h3>
      </div>
      <router-link :to='{name: "storeRedeemableCreate"}' class="router-link">
        <v-btn outlined color="indigo">
          Add
        </v-btn>
      </router-link>
    </div>
    <RedeemableList
        :storeAccount="storeAccount"
    ></RedeemableList>
  </div>
</template>

<script>
import store from "@/store";
import RedeemableList from "@/components/RedeemableList/RedeemableList";

export default {
  name: "Redeemable",
  components: {
    RedeemableList
  },
  computed: {
    storeAccount(){
      return store.state.loggedInAccount
    }
  },

}
</script>

<style scoped>

</style>